// ComposeDisplay.js
export default function (routePath, APP_NAME) {
  return (routePath !== '/app/composer-message' && APP_NAME === 'commercant')
}



// WEBPACK FOOTER //
// ./src/common/lib/ComposeDisplay.js